(function () {
    class TasacionesNumbersOnly {
        constructor() {
            this.selector = 'input[data-numbers-only="1"]';
            this.bound = new WeakSet();
            this.observer = null;
        }

        init() {
            this.enhanceExisting();
            this.observeMutations();
            // WooCommerce puede re-renderizar el checkout
            document.addEventListener('updated_checkout', () => this.enhanceExisting());
        }

        enhanceExisting(root = document) {
            const inputs = root.querySelectorAll(this.selector);
            inputs.forEach((input) => this.bindInput(input));
        }

        bindInput(input) {
            if (!(input instanceof HTMLInputElement)) return;
            if (this.bound.has(input)) return;
            this.bound.add(input);

            // Pistas para teclado móvil
            if (!input.hasAttribute('inputmode')) input.setAttribute('inputmode', 'numeric');
            if (!input.hasAttribute('pattern')) input.setAttribute('pattern', '\\d*');
            

            const allowedKeys = new Set([
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                'Tab', 'Home', 'End', 'Enter', 'Escape'
            ]);

            const onKeyDown = (e) => {
                if (e.ctrlKey || e.metaKey || e.altKey) return;
                if (allowedKeys.has(e.key)) return;
                if (/^[0-9]$/.test(e.key)) return;
                e.preventDefault();
            };

            const sanitize = (el) => {
                const oldVal = el.value || '';
                const caret = el.selectionStart ?? oldVal.length;
                const before = oldVal.slice(0, caret);
                const digitsBefore = before.replace(/\D+/g, '').length;
                const filtered = oldVal.replace(/\D+/g, '');
                if (filtered !== oldVal) {
                    el.value = filtered;
                    const newPos = Math.min(digitsBefore, filtered.length);
                    try { el.setSelectionRange(newPos, newPos); } catch (_) {}
                }
            };

            const onInput = (e) => sanitize(e.target);

            const onPaste = (e) => {
                e.preventDefault();
                let text = (e.clipboardData || window.clipboardData)?.getData('text') || '';
                text = text.replace(/\D+/g, '');
                const el = e.target;
                const start = el.selectionStart ?? el.value.length;
                const end = el.selectionEnd ?? el.value.length;
                const old = el.value || '';
                el.value = old.slice(0, start) + text + old.slice(end);
                const newPos = start + text.length;
                try { el.setSelectionRange(newPos, newPos); } catch (_) {}
                el.dispatchEvent(new Event('input', { bubbles: true }));
            };

            input.addEventListener('keydown', onKeyDown);
            input.addEventListener('input', onInput);
            input.addEventListener('paste', onPaste);
        }

        observeMutations() {
            if (this.observer) return;
            this.observer = new MutationObserver((mutations) => {
                for (const m of mutations) {
                    if (m.type !== 'childList' || m.addedNodes.length === 0) continue;
                    m.addedNodes.forEach((node) => {
                        if (!(node instanceof Element)) return;
                        if (node.matches?.(this.selector)) this.bindInput(node);
                        node.querySelectorAll?.(this.selector).forEach((el) => this.bindInput(el));
                    });
                }
            });
            this.observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
        }
    }

    const instance = new TasacionesNumbersOnly();
    instance.init();
    window.TasacionesNumbersOnly = instance;
})();